import { bankLabel } from '../../utils/bank';
import React, { useState } from 'react';
import SupervisorLayout from '../../components/SupervisorLayout';
import LotteryCodeField from '../../components/LotteryCodeField';
import SupervisorGroupCodeField from '../../components/SupervisorGroupCodeField';
import SupervisorBankCodeField from '../../components/SupervisorBankCodeField';
import DateField from '../../components/DateField';
import { fetchSupervisorTicketsAnnules } from '../../api/supervisor';
import { todayISO } from '../../utils/date';
import './SupervisorTicketsAnnulesPage.css';

const money = (n) => Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const SupervisorTicketsAnnulesPage = () => {
  const [dateFrom, setDateFrom] = useState(todayISO());
  const [dateTo, setDateTo] = useState(todayISO());
  const [lotteryFrom, setLotteryFrom] = useState('');
  const [lotteryFromName, setLotteryFromName] = useState('');
  const [lotteryUp, setLotteryUp] = useState('');
  const [lotteryUpName, setLotteryUpName] = useState('');
  // Filtre Groupe / Banque optionnel, mutuellement exclusif (vide = toutes ses banks).
  const [groupId, setGroupId] = useState('');
  const [groupName, setGroupName] = useState('');
  const [bankId, setBankId] = useState('');
  const [bankName, setBankName] = useState('');

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      setData(await fetchSupervisorTicketsAnnules({
        dateFrom, dateTo, tirageFrom: lotteryFrom, tirageUp: lotteryUp, group: groupId, bank: bankId,
      }));
    } catch (err) {
      setError('Recherche impossible.');
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SupervisorLayout>
      <h2 className="svta-title">Tickets Annulaient</h2>

      <div className="svta-card">
        <form onSubmit={handleSearch} className="svta-form">
          <div className="svta-row">
            <label className="svta-label">De</label>
            <DateField className="svta-input" value={dateFrom} onChange={setDateFrom} />
            <label className="svta-label svta-label-to">À</label>
            <DateField className="svta-input" value={dateTo} onChange={setDateTo} />
          </div>

          <div className="svta-row">
            <label className="svta-label">Loterie De</label>
            <LotteryCodeField
              value={lotteryFrom}
              name={lotteryFromName}
              onChange={(code) => { setLotteryFrom(code); setLotteryFromName(''); }}
              onResolve={(code, nm) => { setLotteryFrom(code); setLotteryFromName(nm); }}
              inputClass="svta-input svta-input-sm"
              iconClass="svta-icon-btn"
              nameClass="svta-scope-name"
            />

            <label className="svta-label svta-label-to">À</label>
            <LotteryCodeField
              value={lotteryUp}
              name={lotteryUpName}
              onChange={(code) => { setLotteryUp(code); setLotteryUpName(''); }}
              onResolve={(code, nm) => { setLotteryUp(code); setLotteryUpName(nm); }}
              inputClass="svta-input svta-input-sm"
              iconClass="svta-icon-btn"
              nameClass="svta-scope-name"
            />
          </div>

          <div className="svta-row">
            <label className="svta-label">Groupe</label>
            <SupervisorGroupCodeField
              value={groupId}
              name={groupName}
              onChange={(id) => { setGroupId(id); setGroupName(''); }}
              onResolve={(id, nm) => {
                setGroupId(id); setGroupName(nm);
                if (id) { setBankId(''); setBankName(''); }
              }}
              inputClass="svta-input svta-input-sm"
              iconClass="svta-icon-btn"
              nameClass="svta-scope-name"
            />

            <label className="svta-label svta-label-to">Banque</label>
            <SupervisorBankCodeField
              value={bankId}
              name={bankName}
              onChange={(id) => { setBankId(id); setBankName(''); }}
              onResolve={(id, nm) => {
                setBankId(id); setBankName(nm);
                if (id) { setGroupId(''); setGroupName(''); }
              }}
              inputClass="svta-input svta-input-sm"
              iconClass="svta-icon-btn"
              nameClass="svta-scope-name"
            />
          </div>

          {error && <p className="svta-error">{error}</p>}
          <button type="submit" className="svta-search-btn" disabled={loading}>
            {loading ? 'Recherche...' : 'Chercher'}
          </button>
        </form>
      </div>

      {data && (
        <div className="svta-card svta-results">
          {data.groups.length === 0 ? (
            <p className="svta-empty">Aucune fiche annulée sur cette période.</p>
          ) : (
            <>
              {data.groups.map((g) => (
                <div key={g.bank_id} className="svta-group">
                  <p className="svta-group-title">{bankLabel(g.bank_seq, g.bank_name)}</p>
                  <table className="svta-table">
                    <thead>
                      <tr>
                        <th>Vente</th><th>Loterie</th><th>O/L</th><th>No.</th>
                        <th>Heure</th><th>Annulé le</th><th>Heure</th><th>Montant</th>
                      </tr>
                    </thead>
                    <tbody>
                      {g.rows.map((r) => (
                        <tr key={r.ticket_id}>
                          <td>{r.sale_date}</td>
                          <td>{r.tirage_code}-{r.tirage_name}</td>
                          <td>{r.online ? 'O' : 'L'}</td>
                          <td>{r.no ?? '—'}</td>
                          <td>{r.sale_time}</td>
                          <td>{r.deleted_date ?? '—'}</td>
                          <td>{r.deleted_time ?? '—'}</td>
                          <td className="svta-money">{money(r.total_amount)}</td>
                        </tr>
                      ))}
                      <tr className="svta-total-row">
                        <td colSpan={3}><strong>Total : {g.totals.tickets} ticket(s)</strong></td>
                        <td colSpan={4}></td>
                        <td className="svta-money"><strong>{money(g.totals.montant)}</strong></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ))}

              <div className="svta-grand-total">
                <span>Total : {data.grand_totals.tickets} ticket(s)</span>
                <span>{money(data.grand_totals.montant)}</span>
              </div>
            </>
          )}
        </div>
      )}
    </SupervisorLayout>
  );
};

export default SupervisorTicketsAnnulesPage;
